<template>
  <hic-dialog append-to-body @open="open" :close-on-click-modal="false" :visible="visible" width="60rem" top="8vh" title="租户编辑" @close="cancel">
    <div style="padding: 0 1rem">
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item title=" " name="1">
          <template slot="title">
            <span>基本信息：{{ value.name }}</span>
          </template>
          <el-form :inline="true" :model="value" :rules="comRules" ref="editor" label-width="8rem" label-position="right" style="padding-right: 5rem" v-loading="loading || saving">
            <el-form-item label="名称" prop="name">
              <el-input type="text" class="editor-input" placeholder="请输入租户名称" v-model.trim="value.name" size="small"> </el-input>
            </el-form-item>
            <el-form-item label="编码" prop="code">
              <el-input type="text" class="editor-input" placeholder="请输入租户编码" v-model.trim="value.code" :disabled="!!value.id" size="small" />
            </el-form-item>
            <el-form-item label="信用代码" prop="creditCode">
              <el-input type="text" class="editor-input" placeholder="请输入租户编码" v-model.trim="value.creditCode" size="small" />
            </el-form-item>
            <el-form-item label="简称">
              <el-input type="text" class="editor-input" placeholder="请输入简称" v-model.trim="value.shortName" size="small" />
            </el-form-item>
            <el-form-item label="排序号" prop="seqNo">
              <el-input type="number" class="editor-input" placeholder="请输入排序号" v-model.number="value.seqNo" size="small" />
            </el-form-item>
            <el-form-item label="电话" prop="phone">
              <el-input type="text" class="editor-input" placeholder="请输入租户电话" v-model="value.phone" size="small" />
            </el-form-item>
            <el-form-item label="类型">
              <hic-dict-selector style="width: 200px" dict-type="TenantType" v-model="value.type" />
            </el-form-item>
            <el-form-item label="级别" v-if="value.type == 'yy'">
              <hic-dict-selector style="width: 200px" dict-type="HospitalGrade" v-model="value.grade" />
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input type="textarea" :rows="2" placeholder="请输入租户地址" v-model="value.address" style="width: 25rem"> </el-input>
            </el-form-item>
            <el-form-item prop="version">
              <el-switch class="editor-input" v-model="value.disabled" active-text="停用" inactive-text="启用" inactive-color="#13ce66" active-color="#ff4949" />
            </el-form-item>
          </el-form>
        </el-collapse-item>
        <el-collapse-item title="应用与权限：" name="2">
          <split-pane :min-percent="10" :default-percent="52" split="vertical" v-loading="loading || saving" style="height: 30rem">
            <template slot="paneL">
              <split-pane split="horizontal">
                <template slot="paneL">
                  <div @drop="toggle" @dragover.prevent class="f-h" style="overflow: auto">
                    <h3 class="center warning">已选应用</h3>
                    <el-row>
                      <el-button v-for="s in selectedSys" :key="s.code" draggable="true" @dragstart.native="dragstart(s, $event)" @dragend.native="dragendOver(s, $event)" class="left-pad bottom-pad" @click="confirm(s)" :type="s == sys.curr ? 'primary' : 'warning'" size="mini" round hit>
                        <span>{{ s.code | dictText("Sys") }}</span>
                      </el-button>
                    </el-row>
                  </div>
                </template>
                <template slot="paneR">
                  <div @drop="toggle" @dragover.prevent class="f-h" style="overflow: auto">
                    <h3 class="center">待选应用</h3>
                    <el-row>
                      <el-button v-for="s in waitingSys" :key="s.code" draggable="true" @dragstart.native="dragstart(s, $event)" @dragend.native="dragendOver(s, $event)" class="left-pad bottom-pad" type="info" size="mini" round>
                        <span>{{ s.code | dictText("Sys") }}</span>
                      </el-button>
                    </el-row>
                  </div>
                </template>
              </split-pane>
            </template>
            <template slot="paneR">
              <div class="f-h" style="overflow: auto">
                <h3 class="center primary">
                  <span v-if="sys.curr" style="color: #409eff">{{ sys.curr.code | dictText("Sys") }}</span>
                  <span v-else> 权限配置 </span>
                </h3>
                <el-tree @check="check" ref="ptree" :data="treeData" :props="{ children: 'children', label: 'name' }" node-key="code" show-checkbox check-on-click-node default-expand-all :expand-on-click-node="false" empty-text="没有可配置的权限"></el-tree>
              </div>
            </template>
          </split-pane>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="save" :disabled="saving" :loading="saving">确 定</el-button>
    </div>
  </hic-dialog>
</template>
<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  import splitPane from "vue-splitpane";
  export default {
    components: {
      splitPane,
    },
    props: {
      visible: Boolean,
      value: Object,
    },
    data() {
      var validateCode = (rule, value, callback) => {
        if (!/^[0-9a-zA-Z_-]*$/.test(value)) {
          return callback(new Error("编码只能包含：【大小写字母】【数字】【_】【-】"));
        }
        return callback();
      };
      var validateTelephone = (rule, value, callback) => {
        if (value && !/^[0-9]*$/.test(value)) {
          return callback(new Error("电话只能包含：【数字】"));
        }
        return callback();
      };
      return {
        comRules: {
          name: [
            { required: true, message: "请输入名称", trigger: "blur" },
            { max: 128, message: "名称长度在 128 个字符以内", trigger: "blur" },
          ],
          code: [
            { required: true, message: "请输入编码", trigger: "blur" },
            { max: 64, message: "编码长度在 64 个字符以内", trigger: "blur" },
            { validator: validateCode, trigger: "blur" },
          ],
          telephone: [
            { max: 32, message: "电话长度在 32 个字符以内", trigger: "blur" },
            { validator: validateTelephone, trigger: "blur" },
          ],
          address: [{ max: 128, message: "地址长度在 128 个字符以内", trigger: "blur" }],
          seqNo: [
            {
              required: true,
              type: "number",
              message: "排序号只能输入数字",
              trigger: "blur",
            },
          ],
        },
        loading: false,
        saving: false,
        sys: {
          items: [],
          curr: null,
        },
        activeName: "1",
      };
    },
    computed: {
      ...mapGetters(["dict"]),
      treeData() {
        return this.sys?.curr?.treeData ?? [];
      },
      waitingSys() {
        return this.sys.items.filter((f) => f.selected === false);
      },
      selectedSys() {
        return this.sys.items.filter((f) => f.selected === true);
      },
    },
    mounted() {
      this.open();
    },
    methods: {
      dragstart(data, event) {
        event.dataTransfer.setData("code", data.code);
      },
      toggle(event) {
        const code = event.dataTransfer.getData("code");
        let sys = this.sys.items.find((s) => s.code == code);
        sys.selected = !sys.selected;
      },
      // disSelect(event) {
      //   const code = event.dataTransfer.getData("code");
      //   let sys = this.sys.items.find((s) => s.code == code);
      //   sys.selected = true;
      // },
      dragendOver(data, event) {
        event.dataTransfer.clearData();
      },
      check(data, obj) {
        this.sys.curr.selectedNodes = this.$refs.ptree.getCheckedNodes(false, true).map((item) => {
          return { code: item.code, name: item.name };
        }); //贮
      },
      confirm(sys) {
        this.sys.curr = sys;
        if (sys.selectedNodes) {
          this.$refs.ptree.setCheckedKeys(this.getLeafKeys(sys.selectedNodes)); //权限设置
        }
      },
      open() {
        this.sys.items = this.dict.Sys.filter((sys) => sys.code != "auth").map((sys) => {
          if (sys.code != "auth") {
            let item = this.$utils.Obj.clone(sys);
            item.selected = false;
            item.treeData = this.$utils.PermissionTree.make(item.permissions);
            return item;
          }
        });
        this.sys.curr = null;
        if (this.$refs.ptree) {
          this.$refs.ptree.setCheckedKeys([]);
        }
        this.saving = false;

        if (this.$refs.editor) {
          this.$refs.editor.clearValidate();
        }

        let _this = this;

        if (this.value.id) {
          this.loading = true;
          api.TenantApply.query({
            tenantId: this.value.id,
            pageIndexOnView: 1,
            pageSize: 999,
          })
            .then((res) => {
              _this.sys.items.forEach((sys) => {
                res.items.forEach((item) => {
                  if (sys.code == item.sysCode) {
                    sys.selected = true;
                    sys.origin = item;
                    if (item.permissions) {
                      sys.selectedNodes = JSON.parse(item.permissions);
                    }
                  }
                });
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      save: function () {
        let _this = this;
        this.$refs.editor
          .validate()
          .then((valid) => {
            _this.saving = true;
            return api.Tenant.save(_this.value);
          })
          .then((newEntity) => {
            _this.$emit("saved", newEntity);
            let ps = [];
            _this.sys.items.forEach((sys) => {
              if (sys.selected) {
                ps.push(
                  api.TenantApply.save({
                    id: sys.origin ? sys.origin.id : null,
                    sysCode: sys.code,
                    tenantId: _this.value.id,
                    permissions: JSON.stringify(sys.selectedNodes),
                  })
                );
              } else if (sys.origin) {
                ps.push(api.TenantApply.del(sys.origin.id));
              }
            });
            return Promise.all(ps); //全部保存成功
          })
          .then((res) => {
            _this.$message.success("保存成功！");
            _this.$emit("update:visible", false);
          })
          .catch((err) => {
            if (err) {
              _this.$message.error(err.message || err);
            }
          })
          .finally(() => {
            _this.saving = false;
          });
      },
      getLeafKeys(nodes) {
        let keys = nodes.filter((n) => nodes.filter((no) => no.code.startsWith(n.code)).length == 1).map((node) => node.code);
        return keys;
      },
    },
  };
</script>
